import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import InxitsLoader from 'components/MutualFunds/InxitsLoader';

/**
 * LoadingFallback - Reusable loading component with optional full‑page overlay and fade‑in effect.
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.fullPage - Whether to cover the full viewport (used for splash/login pages)
 * @returns {React.ReactElement} LoadingFallback
 */
const LoadingFallback = ({ fullPage = false }) => {
  const [visible, setVisible] = useState(false);

  // Trigger fade‑in after mount
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const containerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease-in-out',
    opacity: visible ? 1 : 0,
    ...(fullPage
      ? { height: '100vh', width: '100vw', background: 'linear-gradient(135deg, #13172A, #0f1220)' }
      : { height: '400px', width: '100%', position: 'absolute', top: 100, left: 0, right: 0, bottom: 0, backgroundColor: 'transparent' })
  };

  return (
    <Box sx={containerStyles}>
      <InxitsLoader size={100} />
    </Box>
  );
};

LoadingFallback.propTypes = {
  fullPage: PropTypes.bool,
};

export default LoadingFallback;
